import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faCheck, faGraduationCap, faLightbulb, faLinesLeaning, faPencilRuler, faPlugCircleCheck } from "@fortawesome/free-solid-svg-icons";

// The access keys stored on the account, in the order they are shown. They are
// the same keys Categories checks before letting a module open.
export interface ModuleOption {
    key: string;
    group: "low" | "high";
    icon: any;
    ro: string;
    en: string;
}

export const ACCESS_MODULES: ModuleOption[] = [
    { key: "edit", group: "low", icon: faPencilRuler, ro: "Editare schemă", en: "Edit scheme" },
    { key: "functional", group: "low", icon: faLightbulb, ro: "Funcționare scheme", en: "Functional schemes" },
    { key: "debug", group: "low", icon: faPlugCircleCheck, ro: "Depanare schemă", en: "Debug scheme" },
    { key: "learn", group: "high", icon: faLinesLeaning, ro: "Învățare", en: "Learning" },
    { key: "train", group: "high", icon: faBook, ro: "Antrenare", en: "Training" },
    { key: "test", group: "high", icon: faGraduationCap, ro: "Testare", en: "Testing" },
];

/** The module-access toggles shared by the account forms. */
const ModulesPicker = ({
    value, onToggle, en, available,
} : {
    value: string[];
    onToggle: (key: string) => void;
    en?: boolean;
    /** Keys the author may hand out. Omitted = all of them. A teacher can only
        pass on the modules their own account holds. */
    available?: string[];
}) => {

    const offered = available
        ? ACCESS_MODULES.filter((m) => available.includes(m.key))
        : ACCESS_MODULES;

    const group = (g: "low" | "high") => (
        <div className="acc-mod-group">
            <p className={`acc-kicker ${g}`}>
                <span className="acc-kicker-dot" />
                {g === "low"
                    ? (en ? "Low tension" : "Joasă tensiune")
                    : (en ? "High tension" : "Înaltă tensiune")}
            </p>

            {offered.filter((m) => m.group === g).map((m) => {
                const on = value?.includes(m.key);
                return (
                    <button
                        key={m.key}
                        type="button"
                        className={`acc-module${on ? " on" : ""}`}
                        aria-pressed={on}
                        onClick={() => onToggle(m.key)}
                    >
                        <span className="acc-module-icon"><FontAwesomeIcon icon={m.icon} /></span>
                        <span className="acc-module-name">{en ? m.en : m.ro}</span>
                        <span className="acc-module-check">{on ? <FontAwesomeIcon icon={faCheck} /> : null}</span>
                    </button>
                );
            })}
        </div>
    );

    const has = (g: "low" | "high") => offered.some((m) => m.group === g);

    return (
        <div className="acc-modules">
            {has("low") ? group("low") : null}
            {has("high") ? group("high") : null}
        </div>
    );
};

export default ModulesPicker;
